module.exports = __webpack_public_path__ + "media/images/brand/note_link-e0a3fcf607568599188b17616ae5c650.svg";